import React, {useState} from 'react';
import {getFormData, inputChangedHandler, prepareFormData, validateForm} from "../shared/utility";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import {connect} from "react-redux";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Box} from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles((theme) => ({
    heading: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "20px",
        lineHeight: "25px",
        color: "#00AEEF",
        paddingBottom: "8px",
        paddingTop: "10px",
    },
    label: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "flex-end",
        color: "#FEFFFF",
        paddingBottom: "4px"
    },
    formElement: {
        paddingBottom: "8px",
        '& .MuiFormHelperText-contained': {
            marginLeft: "0px",
        },
    },
    buttonProgress: {
        color: green[500],
        marginLeft: theme.spacing(1),
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    button: {
        marginLeft: theme.spacing(1),
    },
    input: {
        backgroundColor: "transparent",
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        color: "#FEFFFF"
    },
}));


let formData = {
    controls: {
        owner: {
            label: 'Do you own the vehicle outright?',
            value: "",
            values: [
                {key: "yes", value: "Yes"},
                {key: "loan", value: "No - Loan"},
                {key: "lien", value: "No - Lien"},
                {key: "lease", value: "No - Lease"}],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        },

        runnable: {
            label: 'Does the vehicle run?',
            value: "",
            values: [{key: true, value: "Yes"}, {key: false, value: "No"}],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        },
        dashboardLights: {
            label: 'Are any Dashboard Warning Lights on?',
            value: "",
            values: [{key: true, value: "Yes"}, {key: false, value: "No"}],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        },

        hasAccident: {
            label: 'Has the vehicle been in an accident?',
            value: "",
            values: [{key: true, value: "Yes"}, {key: false, value: "No"}],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        },
        smokedIn: {
            label: 'Has the vehicle ever been smoked in?',
            value: "",
            values: [{key: true, value: "Yes"}, {key: false, value: "No"}],
            validation: {
                presence: {allowEmpty: false}
            },

            valid: false,
            touched: false,
        },
        floodFireDamage: {
            label: 'Is there any flood or fire damage?',
            value: "",
            values: [{key: true, value: "Yes"}, {key: false, value: "No"}],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        },
        hailDamage: {
            label: 'Is there any rust or hail damage?',
            value: "",
            values: [{key: true, value: "Yes"}, {key: false, value: "No"}],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        },
        hasAftermarketParts: {
            label: 'Are any aftermarket parts installed?',
            value: "",
            values: [{key: true, value: "Yes"}, {key: false, value: "No"}],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        }

    },


    loading: false,
    valid: false,
    touched: false,
    generalError: null

}

const QualifyingQuestionsComponent = (props) => {

    const classes = useStyles();

    const [formState, setFormState] = useState(formData);
    React.useEffect(() => {
        const state = {}
        for (let key in formData.controls) {
            console.log(key, props.vehicle[key])
            if (props.vehicle[key] !== undefined && props.vehicle[key] !== "") {
                if (key === 'owner') {
                    console.log(props.vehicle[key], 'selectedVehicle')
                    state[key] = props.vehicle[key] ?? ""
                } else {
                    console.log(props.vehicle[key], 'selectedVehicle')
                    state[key] = props.vehicle[key] ? true: false
                }
            } else {
                state[key] = ""
                console.log(formData.controls[key].value, 'controlValue')
            }
        }

        console.log(state, props.vehicle)
        formData = prepareFormData(formData, state);
        console.log(formData)
        setFormState(formData);
    }, [props.vehicle.id])

    const submitHandler = async (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            const data = getFormData(formState)
            props.onNext(data, nextStep => {

            })
        }
    }


    const formElements = []
    for (let key in formState.controls) {
        let el = formState.controls[key]
        formElements.push(
            <Box className={classes.formElement} key={key}>
                <Box className={classes.label}>{el.label}</Box>
                <FormControl className={classes.formControl} fullWidth
                             error={!el.valid && el.touched} margin={"normal"} key={key}>

                    <Select
                        key={key}
                        labelId="{conditionField.key}-label"
                        id={el.key}
                        value={el.value}
                        displayEmpty
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, el.key)}
                        error={!el.valid && el.touched}
                        margin="dense"
                        variant="outlined"
                        className={classes.input}
                    >
                        <MenuItem value="" className={classes.input}>
                            <em>--Select--</em>
                        </MenuItem>
                        {el.values.map((item, i) => (
                            <MenuItem key={key + i} value={item.key} className={classes.input}>{item.value}</MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>{!el.valid && el.touched ? el.helperText : ""}</FormHelperText>
                </FormControl>
            </Box>
        )
    }


    return (
        <React.Fragment>

            {props.app.error &&
            <div className={classes.wrapper}>
                <Alert severity="error">{props.app.error ?? ''}</Alert>
            </div>
            }
            <Box className={classes.heading}>General Questions</Box>

            {formElements}

            <Box display="flex" justifyContent="flex-end" style={{marginTop: '16px', marginBottom: '30px'}}>
                <div className={classes.wrapper}>
                    <Button className={classes.button} type={"button"} variant={"outlined"} onClick={props.onBack}
                    >  {props.backButton}</Button>

                    <Button
                        className={classes.button}
                        type={"button"}
                        variant={"contained"}
                        color={"primary"}
                        onClick={submitHandler}
                    > Next {props.app.loading &&
                    <CircularProgress size={24} className={classes.buttonProgress}/>}</Button>

                </div>
            </Box>

        </React.Fragment>
    );

}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(QualifyingQuestionsComponent);
